module.exports = __webpack_public_path__ + "img/header-diamondJewelryPresentsYearly.33e9d93.webp";